// This file exists because the error logging mechanisms on the frontend and
// backend are different and are best not required at all. Instead, we have
// frontend and backend initialization code set an error logging function to
// use here, and then we can use this file's logError from anywhere.

let injectedLogger = null;

// Pass a function that takes type, message, data like ErrorUtil does.
const setErrorLogger = function(f) {
	if (typeof f !== "function") {
		throw new Error("setErrorLogger must be passed a function");
	}
	injectedLogger = f;
};

// Where the frontend uses ErrorUtil.log and the backend uses log.error, files
// in shared should use this function.
const logError = function(type, message, data) {
	if (typeof injectedLogger !== "function") {
		// Try to detect a missing setErrorLogger step in development. This should
		// work on both frontend and backend.
		if (process.env.NODE_ENV !== "production") {
			throw new Error("Called SharedError.logError without setting a logger");
		}
		return;
	}
	injectedLogger(type, message, data);
};

module.exports = {
	setErrorLogger,
	logError,
};
